import React from 'react';

interface CycleCountByItemFormStructureProps {
    inputFields: React.ReactNode[];
}

const CycleCountByItemFormStructure: React.FC<CycleCountByItemFormStructureProps> = ({ inputFields }) => {
    return (
        <>
            <div className="my-2 bg-white rounded py-1 px-2 ">
                <div className="checkin-details col-12 bg-white col-12 py-2 px-3 ">
                    <div className="row">
                        {inputFields.map((field, index) => (
                            <div key={index} className="col-lg-3 col-md-2 col-sm-6 pe-3">
                                {field}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default CycleCountByItemFormStructure;
